<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-4"></div>
      <div class="col-4">
        <h2 class="display-3 text-center edu-au-vic-wa-nt-pre-unique-style bounceInLeft" style="color:#303030">
          Procesos Legales
        </h2>

        <h3
          class="display-4 text-center mb-4 edu-au-vic-wa-nt-pre-unique-style"
          :class="animClass"
          :style="{ color: colorPorEstatus }"
        >
          {{ tituloPorEstatus }}
        </h3>
      </div>
    </div>

    <br />

    <div class="mb-1 d-flex align-items-md-end gap-5 justify-content-center">
      <div class="w-25 text-center">
        <label for="estadoProceso" class="text-center">Mostrar:</label>
        <select v-model="filtradoEstatus" id="estadoProceso" class="form-select p-2">
          <option value="Todos">Todos</option>
          <option v-for="opt in estatusOptions" :key="opt" :value="opt">{{ opt }}</option>
        </select>
      </div>
    </div>

    <TablaProcesos :key="filtradoEstatus" :estatus="filtradoEstatus" />
  </div>
</template>

<script>
import TablaProcesos from './TablaProcesos.vue';

export default {
  name: 'MostrarProcesos',
  components: { TablaProcesos },
  data() {
    return {
      filtradoEstatus: 'Todos',
      estatusOptions: [
        'NOTIFICADA',
        'POR NOTIFICAR',
        'PRESENTADA',
        'RECHAZADA',
        'RETORNADA',
        'SUBSANADA',
        'TRABAJO',
        'ADMITIDA', // Asegúrate de que este estatus esté en tu lista de opciones
      ],
    };
  },
  computed: {
    tituloPorEstatus() {
      return this.filtradoEstatus === 'Todos' ? 'Todos' : this.filtradoEstatus;
    },
    colorPorEstatus() {
      const map = {
        NOTIFICADA: '#0084C9',
        'POR NOTIFICAR': '#FFA700',
        PRESENTADA: '#00A632',
        RECHAZADA: '#dc3545',
        RETORNADA: '#6f42c1',
        SUBSANADA: '#20c997',
        TRABAJO: '#6c757d',
        ADMITIDA: '#17a2b8', // Asegúrate de que este color esté definido
        Todos: '#e0e0e0',
      };
      return map[this.filtradoEstatus] || '#e0e0e0';
    },
    animClass() {
      // alterna anim para que se note el cambio
      return ['bounceInLeft', 'bounceInRight'][Number(new Date()) % 2];
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Edu+AU+VIC+WA+NT+Pre:wght@400..700&display=swap');
</style>

<style scoped>
.edu-au-vic-wa-nt-pre-unique-style {
  font-family: "Edu AU VIC WA NT Pre", cursive;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

/* Reuso de tus animaciones */
.bounceInLeft { animation: bounceInLeft 1s both; }
@keyframes bounceInLeft {
  0% { opacity:0; transform: translate3d(-3000px,0,0); }
  60% { opacity:1; transform: translate3d(25px,0,0); }
  75% { transform: translate3d(-10px,0,0); }
  90% { transform: translate3d(5px,0,0); }
  100% { transform: none; }
}
.bounceInRight { animation: bounceInRight 1s both; }
@keyframes bounceInRight {
  0% { opacity:0; transform: translate3d(3000px,0,0); }
  60% { opacity:1; transform: translate3d(-25px,0,0); }
  75% { transform: translate3d(10px,0,0); }
  90% { transform: translate3d(-5px,0,0); }
  100% { transform: none; }
}
</style>
